import React, { forwardRef, useImperativeHandle, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ContactUsForm from "../Contact-us/ContactUsForm";
import Image from "next/image";
import ContactElchemy from "../Common/contact-elchemy";
import { contactUsOptions } from "@/constastants/Constant";

const ContactUsModalBtn = forwardRef(
  (
    {
      heading,
      subHeading,
      children,
      classes,
      defaultValue = "",
      options = [],
      service = "",
      submitButtonLabel,
      submitButtonWidth,
      additionalInformationInitialValue,
      productId = null,
      isUsVersion = false, // <-- add prop
      gtmSubmitEvent = "",
    },
    ref,
  ) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => {
      return {
        setOpen,
        open,
      };
    });
    const handleClickOpen = (e) => {
      e?.stopPropagation();
      e?.preventDefault();
      setOpen(true);
      // GTM tracking moved to ContactElchemy component on mount
    };

    const handleClose = (e) => {
      e?.stopPropagation();
      e?.preventDefault();
      setOpen(false);
    };

    return (
      <>
        {children && (
          <button className={classes} onClick={(e) => handleClickOpen(e)}>
            {children}
          </button>
        )}
        <div className="">
          {/*
            ⚠️ Do NOT put `onClick={(e) => e.stopPropagation()}` on <Dialog>.
            MUI attaches its backdrop-click handler to `.MuiDialog-container` and
            only closes when `event.target === event.currentTarget` — and the
            backdrop/container render INSIDE the Dialog root, so a stopPropagation
            there swallows the click and the modal never closes on outside click.
            The guard belongs on the Paper (below), which is what actually needs to
            keep clicks from reaching the product card this modal is nested in.
          */}
          <Dialog
            open={open}
            onClose={(e) => handleClose(e)}
            maxWidth="md"
            fullWidth
            PaperProps={{
              onClick: (e) => e.stopPropagation(),
              ...(isUsVersion
                ? {
                    sx: {
                      borderRadius: "20px",
                    },
                  }
                : {}),
            }}
          >
            <div className="flex justify-between p-6">
              <div
                className={`flex gap-[2px]${
                  isUsVersion ? " w-full flex-col items-center" : ""
                }`}
              >
                {!isUsVersion && (
                  <Image
                    src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709289729.svg"
                    width={64}
                    height={72}
                    className="relative h-8 sm:h-14 md:h-16 ml-[-1rem]  sm:ml-[0] mb-2 "
                    alt="brand-logo"
                  />
                )}
                <div
                  className={
                    isUsVersion ? "w-full flex flex-col items-center" : ""
                  }
                >
                  <div
                    className={`sm:text-[30px] text-[1.2rem] font-normal font-mukta mb-[4px]${
                      isUsVersion ? " text-center w-full" : ""
                    }`}
                    style={
                      isUsVersion
                        ? {
                            fontWeight: 500,
                            fontSize: "24px",
                            lineHeight: 1.16,
                            textAlign: "center",
                            color: "#2C2F38",
                          }
                        : {}
                    }
                  >
                    {heading}
                  </div>
                  <div
                    className={`md:text-[1rem] font-semibold text-[0.8rem] text-[#4D4D4D] font-mukta${
                      isUsVersion ? " text-center w-full" : ""
                    }`}
                  >
                    {subHeading}
                  </div>
                </div>
              </div>
              <ClearIcon
                className="cursor-pointer mt-4"
                onClick={(e) => handleClose(e)}
              />
            </div>
            <DialogContent onClick={(e) => e.stopPropagation()}>
              <ContactElchemy
                options={options.length > 0 ? options : contactUsOptions}
                handleClose={handleClose}
                service={service}
                submitButtonLabel={submitButtonLabel}
                submitButtonWidth={submitButtonWidth}
                additionalInformationInitialValue={
                  additionalInformationInitialValue
                }
                productId={productId}
                isUsVersion={isUsVersion}
                gtmSubmitEvent={gtmSubmitEvent}
              />
            </DialogContent>
          </Dialog>
        </div>
      </>
    );
  },
);

ContactUsModalBtn.displayName = "ContactUsModalBtn";
export default ContactUsModalBtn;
